import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-password-succeeded',
  templateUrl: './password-reset-succeeded.page.html',
  styleUrls: ['./password-reset-succeeded.page.scss'],
})
export class PasswordResetSucceededPage implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
